export const PRODUCT_NAME = "Brandly";

export const COPYRIGHT_NAME = "Brandly";
